
  <!-- content begin -->
  <div id="content" class="no-bottom no-top">
    <div id="top"></div>


  <!-- section begin -->
  <section id="subheader" class="text-light" data-bgimage="url(assets/images/background/10.jpg)" data-stellar-background-ratio=".2" style="background: url(assets/images/background/16.jpg) 0% 0px / cover; " >
    <div class="overlay-bg t50" style="background: rgba(30, 30, 30, .5)">

        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <h1>About the post</h1>
                </div>
            </div>
        </div>

    </div>

</section>
<!-- section close -->



<div class="row notifi_main ">
  <div class="col-md-12">
<h2>
    Consultant-Entrepreneurship  
</h2>

<p style="padding: 20px 0px 0px;">Ministry of Skill Development and Entrepreneurship under Skills Acquisition and Knowledge Awareness for Livelihood Promotion (SANKALP) programme which is an outcome-oriented centrally sponsored program supported by World Bank..</p>

  </div>
</div>


    <!-- section begin -->
    <section id="section-services">
        <div class="container">

            <div class="row align-items-center">
    <div class="col-md-12">
      <div class="row sequence">


        <!-- feature box begin -->
        <div class="col-md-12 mb40 sq-item wow sq-item wow">
            <div class="feature-box style-2 left">
              <i class="fa fa-graduation-cap"></i>
              <div class="text para_cls">
                <h3>Project Background: </h3>
                <!-- <p> <span class="step_no">1</span>Communication in multiple languages (Option)-English, Tamil, Hindi, any other  </p> -->
                <p> <span class="step_no">1</span>Entrepreneurship Division of Ministry of Skill Development and Entrepreneurship is
                    responsible in conceptualizing, planning and implementing various schemes and programmes
                    for promoting entrepreneurship in India. It is mandated to promote entrepreneurship education
                    and provide necessary ecosystem support services for fostering entrepreneurship among youth,
                    women and marginalized sections</p> 
              </div>
            </div>
          </div>
          <!-- feature box close -->
  
        <!-- feature box begin -->
        <div class="col-md-12 mb40 sq-item wow sq-item wow">
            <div class="feature-box style-2 left">
              <i class="fa fa-graduation-cap"></i>
              <div class="text para_cls">
                <h3>Consultant shall be responsible for the following activities: </h3>
                <!-- <p> <span class="step_no">1</span>Communication in multiple languages (Option)-English, Tamil, Hindi, any other  </p> -->
                    <p> <span class="step_no">1</span>Manage and facilitate entrepreneurship initiatives of Ministry and provide support to
                    the Ministry in planning and implementing schemes and programs   </p> 
                    <p> <span class="step_no">2</span>Support the Ministry in review and monitor the existing schemes and programmes on
                        entrepreneurship.   </p> 
                    <p> <span class="step_no">3</span>Support Ministry in bringing collaboration and partnership with various stakeholders   </p> 
                    <p> <span class="step_no">4</span>Closely work with national institutions and state institutions and agencies for
                        entrepreneurship promotion among skilled youth.   </p> 
                    <p> <span class="step_no">5</span>Support the ENP division of Ministry in entrepreneurship related content and
                        curriculum development, concept notes, analytical reports and other project and policy
                        documents, research studies, evaluations, assessments, data collection and report
                        development.   </p> 
                    <p> <span class="step_no">6</span>Liaison and support State Skill Missions (SSM) to take up entrepreneurship
                        intervention pan India   </p> 
                    <p> <span class="step_no">7</span>Support ministry in building a pan India entrepreneurship ecosystems which include
                        systems for entrepreneurship education, digital networks, mentors and mentor agencies,
                        etc   </p> 
                    <p> <span class="step_no">8</span>Conduct review of project reports, case studies, assessments and facilitate access to
                        different platform for disseminations   </p> 
                    <p> <span class="step_no">9</span>Planning and coordination of innovation events, trainings, national awards, workshops,
                        conferences, visits, and exchange programme etc.    </p> 
                                                                                                                                                                    
              </div>
            </div>
          </div>
          <!-- feature box close -->         

        <!-- feature box begin -->
        <div class="col-md-12 mb40 sq-item wow sq-item wow">
          <div class="feature-box style-2 left">
            <i class="fa fa-graduation-cap"></i>
            <div class="text para_cls">
              <h3>Qualification: </h3>
              <!-- <p> <span class="step_no">1</span>Communication in multiple languages (Option)-English, Tamil, Hindi, any other  </p> -->
              <p> <span class="step_no">1</span>Master Degree in either Business Management or Community Development or Rural Management or
                Social Work or Social science.   </p> 
            </div>
          </div>
        </div>
        <!-- feature box close -->




  <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-history"></i>
      <div class="text para_cls">
        <h3>Experience:</h3>

        <p> <span class="step_no">1</span>10 years of professional experience, including minimum 5 years of relevant experience in
            (either or joint) entrepreneurship/self-employment promotion, entrepreneurship education, skill 
            development and deployment, education, research and communication, rural and urban livelihood
            development, content development, capacity building and training, life skills and mentoring,
            monitoring and evaluation, etc </p>
        <p> <span class="step_no">2</span>Work experience in designing, planning and implementing schemes and programmes and
        policy interventions with government and/or reputed development organisations or
        international/ multilateral agencies </p>
        <p> <span class="step_no">3</span>Experience in managing various stakeholders and agencies and building partnership and
        networking. </p>
        <p> <span class="step_no">4</span>Experience in monitoring and evaluation of schemes and programmes at government or
        private sector. </p>
        

       </div>
    </div>
  </div>
  <!-- feature box close -->


  <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-history"></i>
      <div class="text para_cls">
        <h3>Age:</h3>

        <p> <span class="step_no">1</span>below 45 years </p>


       </div>
    </div>
  </div>
  <!-- feature box close -->

  <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-money"></i>
      <div class="text para_cls">
        <h3>Remuneration:</h3>
        <p>Remuneration range will be Rs. 50,000/- to 2,00,000/- per month as consolidated pay from
            which standard TDS will be deducted at source. Not entitled to any other allowance or benefits. </p>

      </div>
    </div>
  </div>
  <!-- feature box close -->
  <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-calendar"></i>
      <div class="text para_cls">
        <h3>Last Date:</h3>
        <p style="color: red;"><b> Last date for Applying Online 7th February 2022 </b> </p>
      </div>
    </div>
  </div>
  <!-- feature box close --> 

  <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-cogs"></i>
      <div class="text para_cls">
        <h3>Skills and Competencies:</h3>
        <p><span class="step_no">1</span>Good communication skills </p>
        <p><span class="step_no">2</span>Strong analytical and documentation skills </p>
        <p><span class="step_no">3</span>Experience of using computer applications including MS Office Application and other
            research applications </p>
        <p><span class="step_no">4</span>Should have experience in implementing projects in multi stakeholder environment. 
        </p>
        <p><span class="step_no">5</span>Strong presentation skills and interpersonal skills </p>
        <p><span class="step_no">6</span>Should be able to operate in unstructured environment with minimal support. </p>
        <p><span class="step_no">7</span>Openness to travel if required  </p>
                            

      </div>
    </div>
  </div>
  <!-- feature box close -->



          <!-- feature box begin -->
    <div class="col-md-12 feature-box mb40 sq-item wow">
        <div class="feature-box style-2 left">
          <i class="fa fa-cogs"></i>
          <div class="text para_cls">
            <h3>Nature of engagement:</h3>
            <p><span class="step_no">1</span>Annual contract with performance based extension of contract as per project requirement. </p>
          </div>
        </div>
      </div>
      <!-- feature box close -->



    <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-globe"></i>
      <div class="text para_cls">
        <h3>Locations</h3>
       		<p><span class="step_no">1</span>Delhi</p>





      </div>
    </div>
  </div>
  <!-- feature box close -->

  

  <div class="container big_padd">








      </div>


    </div>
    <!-- content close -->




    <style>
      #section-intro{
        background-image: url(assets/images/background/niminew.jpg);
    background-size: cover;
    background-position: 0% 0px;
    height: 80vh !important;
      }
      .notifi_main{
        text-align: center;
        padding: 40px 0px;
      }

      .notifi_main h2{
        border-bottom: 6px solid #F56B55;
    width: fit-content;
    margin: 0 auto;
    padding: 0px 30px;
      }
      .notifi_main .descrip_cls{
        padding: 5px 0px;
    font-weight: 500;
    font-size: 21px;
      }

      .overlay-bg.t50{
        background: rgba(30, 30, 30, .1);
      }

      table{
      width: 100%;
      margin-top: 10px;
    }
    th, td{
      padding: 10px;
    }
    thead{
      background-color: #F56B55;
      color: #fff;
    }
    tr:nth-child(odd){
      background-color: #eee;
    }
    .step_no{
      left: 80px;
    height: 30px;
    width: 30px;
    background-color: #F56B55;
    border-radius: 50%;
    display: inline-block;
    font-size: 18px;
    text-align: center;
    color: #fff;
    margin-right: 10px;
    position: absolute;
    }

    .para_cls p{
      padding-left: 35px;
    }
    .num_marks{
      text-align: center;
    }
    .last_tr{
      background-color: #F56B55 !important;
      color: #fff;
    }
    .notifi_main_table h2{

    width: fit-content;
    margin: 0 auto;
    padding: 50px 30px 10px;
    font-size: 23px;

    }
    .para_main_notify{
      padding: 20px 0px;
    width: 50%;
    margin: 0 auto;
    }
  #section-services{
      padding: 0px !important;
    }
    </style>
